import React from "react";

type Props = {
  children: React.ReactNode;
};

export const LayoutPlp: React.FC<Props> = ({ children }: Props) => {
  return (
    <div className="ps-page--shop">
      <div className="ps-container">
        <div className="ps-layout--shop">{children}</div>
      </div>
    </div>
  );
};
